import { Radio } from "@validereinc/common-components";
import { ChoiceType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React from "react";
import styles from "./WorkflowTaskUserChoice.module.scss";

const cx = classNames.bind(styles);

type Props = { choices: ChoiceType[] };

type SelectableProps = Props & {
  selectedChoiceId: string;
  setSelectedChoiceId: (choiceId: string) => void;
  isDisabled: boolean;
  readOnly?: false;
};

type ReadOnlyProps = Props & {
  readOnly: true;
};

export const WorkflowTaskUserChoice = (
  props: SelectableProps | ReadOnlyProps
) => {
  const readOnly = props.readOnly;

  const options = props.choices.map((choice) => {
    return {
      title: choice.name,
      description: choice.description,
      value: choice.id,
    };
  });

  return (
    <div
      className={cx({
        "choice-section-container": true,
        "is-disabled": !readOnly && props.isDisabled,
        "read-only": readOnly,
      })}
    >
      <p className={cx("choice-section-title")}>Choices</p>
      <Radio
        className={cx("choice-card-container")}
        optionClassName={cx("choice-card")}
        name="user-choice"
        value={readOnly ? "" : props.selectedChoiceId}
        onChange={(selectedOption) => {
          if (!readOnly) props.setSelectedChoiceId(selectedOption);
        }}
        options={options}
        isLoading={!props.choices?.length}
        isDisabled={(!readOnly && props.isDisabled) || !!readOnly}
        shouldUseRadioSelectionCard
      />
    </div>
  );
};
